// Meta Pixel event helpers - safe to call before fbq is loaded
export function fbqTrack(event, params) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      if (params) {
        window.fbq("track", event, params);
      } else {
        window.fbq("track", event);
      }
    }
  } catch (e) {
    /* silently ignore pixel errors */
  }
}

export const trackAddToCart = (item) => {
  fbqTrack("AddToCart", {
    content_name: item?.name,
    content_ids: item?.product_id ? [item.product_id] : undefined,
    content_type: "product",
    value: Number(item?.price) * Number(item?.quantity || 1),
    currency: "XOF",
  });
};

export const trackInitiateCheckout = ({ items = [], value }) => {
  fbqTrack("InitiateCheckout", {
    content_ids: items.map((i) => i.product_id),
    content_type: "product",
    num_items: items.reduce((s, i) => s + Number(i.quantity || 1), 0),
    value: Number(value || 0),
    currency: "XOF",
  });
};

export const trackPurchase = ({ items = [], value, order_number }) => {
  fbqTrack("Purchase", {
    content_ids: items.map((i) => i.product_id),
    content_type: "product",
    num_items: items.reduce((s, i) => s + Number(i.quantity || 1), 0),
    value: Number(value || 0),
    currency: "XOF",
    order_id: order_number,
  });
};

export const trackViewContent = (product) => {
  fbqTrack("ViewContent", {
    content_name: product?.name,
    content_ids: product?.id ? [product.id] : undefined,
    content_type: "product",
    value: Number(product?.price || 0),
    currency: "XOF",
  });
};
